import { ChangeEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutEscrowReconciliation } from "./autogen/AutogenLayoutEscrowReconciliation";

export class EscrowReconciliation extends AutogenLayoutEscrowReconciliation {
    onLoad(): void | Promise<void> {
        this.excludabletextboxGLAccounts.switchRange.addChangeListener((event: ChangeEvent) => {
            const rangeStart = this.excludabletextboxGLAccounts.textboxRangeStart;
            const rangeEnd = this.excludabletextboxGLAccounts.textboxRangeEnd;
            const listener = this.textboxEscrowAccountstextboxBeforeLookupModelSearch;

            if (event.newValue) {
                rangeEnd.addBeforeLookupModelSearchListener(listener);
                rangeStart.addBeforeLookupModelSearchListener(listener);
            } 
        });
        this.checkboxIncludeAdjustments.checked = true;
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEscrowAccounts-textbox. */
    textboxEscrowAccountstextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
        event.filter.is_escrow = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of excludabletextboxPayees-textbox. */
    textboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = 'Y';
    }
}
